import { css } from 'emotion'
import { Easings } from './..'
import { Link, Colors, MenuH2, Subtitle, TopMenuMobileStyle } from './..';
import { Font } from '../core';
import { clientRect } from 'chirashi';

// Panel
export const PanelStyle = (theme, open, isMobile, load) => css({
  position: 'fixed',
  top: 60,
  left: 0,
  width: '100%',
  height: '100%',
  overflow: 'auto',
  background: theme,
  zIndex: isMobile ? 3 : 1,
  transform: `scaleY(${open ? 1 : 0})`,
  transformOrigin: 'center top',
  transition: `transform ${ open ? 600 : 300}ms ${ Easings.customEase } ${open ? 0 : 300}ms`,
  lineHeight: 1,
  '.panel-transition': {
    transition: `opacity ${open && load ? 600 : 200}ms ease ${open && load ? 600 : 0}ms`,
    opacity: open && load ? 1 : 0 ,
    height: '100%',
    position: 'relative',
  },
  '@media (min-width: 1024px)': {
    top: 0,
    paddingTop: '80px',
  }
})

// Base Style
export const BaseStyle = (bgd, load) => css({
  position: 'relative',
  padding: '2rem 3rem 4rem 3rem',
  background: `url(${bgd}) no-repeat center`,
  backgroundSize: 'cover', 
  minHeight: '100%',
  transition: `opacity 300ms ease`,
  '@media (min-width: 1024px)': {
    padding: '6rem',
  },
  '.panel-content': {
    position: 'relative',
    zIndex: 2,
    opacity: load ? 1 : 0,
    transform: `translateY(${load ? 0 : 20}px)`,
    transition: `all 1s ${Easings.customEase} ${load ? 600 : 0}ms`,
  },
  '.panel-inner': {
    '&--categories': {
      position: 'relative',
      zIndex: 2,
      maxWidth: '100%',
      flexBasis: '100%',
      '@media (min-width: 1024px)': {
        maxWidth: 'calc(2/3 * 100%)',
        flexBasis: 'calc(2/3 * 100%)',
      },
      'h2': {
        ...MenuH2,
        color: Colors.mediumGrey,
      },
      'li':{
        margin: '1rem 0px',
      },
      'a': {
        ...Link,
        fontSize: '1.125rem',
        letterSpacing: 0,
        color: Colors.grey,
        transition: 'color 400ms ease',
        '&.link-all': {
          fontSize: '0.75rem',
          letterSpacing: '2.5px',
          color: 'white',
          position: 'relative',
          display: 'inline-block',
          marginTop: '2rem',
          '&:after': {
            content: '""',
            position: 'absolute',
            bottom: -5,
            left: 0,
            width: '100%',
            height: 1,
            background: 'white',
            transition: `transform 200ms ${Easings.customEase}`,
            transformOrigin: 'center left',
            transform: 'scaleX(0)',
          },

          '&:hover': {
            '&:after': {
              transform: 'scaleX(1)',
            }
          }
        },

        '&:hover, &.active': {
          color: 'white',
        }
      },
      '.category': {
        maxWidth: '100%',
        flexBasis: '100%',
        '@media (min-width: 768px)': {
          maxWidth: '50%',
          flexBasis: '50%',
        },
      },
    },
    '&--push': {
      position: 'relative',
      zIndex: 2,
      maxWidth: '100%',
      flexBasis: '100%',
      margin: '4rem 0',
      '@media (min-width: 1024px)': {
        maxWidth: 'calc(1/3 * 100%)',
        flexBasis: 'calc(1/3 * 100%)',
        margin: 0,
      },
      'h3': {
        color: 'white',
        transform: 'translateX(-1.5rem)',
        '@media (min-width: 1024px)': {
          transform: 'none',
        }
      }
    },
  }
}, bgd !== '' && {
  '&:after': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: 'black',
    opacity: '0.8',
    zIndex: 1,
  },
})

// Challenge
export const ChallengePanelStyle = (bgd, load) => css({
  minHeight: '100%',
  background: `white url(${bgd}) no-repeat center`,
  backgroundSize: 'cover',
  transition: `opacity 300ms ease`,
  // padding: '0px 3rem',
  // '@media (min-width: 1024px)': {
  //   padding: '4rem 8rem',
  // },
  '.panel-challenge-content': {
    opacity: load ? 0.99 : 0.01,
    transform: `translateY(${load ? 0 : 20}px)`,
    transition: `all 1s ${Easings.customEase} ${load ? 600 : 0}ms`,
    paddingBottom: '4rem',
  },
  '.challenge-panel': {
    '&-top': {
      justifyContent: 'center',
      textAlign: 'center'
    },
    '&-title': {
      color: Colors.red,
      marginBottom: '4rem',
      maxWidth: '100%',
      flexBasis: '100%',
      '@media (min-width: 1024px)': {
        maxWidth: 'calc(2/3 * 100%)',
        flexBasis: 'calc(2/3 * 100%)',
      },
      'h2': {
        ...MenuH2,
        fontFamily: Font.title_font_bold,
        margin: 0,
        textTransform: 'uppercase',
        fontWeight: 'bold',
      },
      'span': {
        ...Subtitle,
        fontWeight: 'bold',
      }
    },
    '&-push': {
      justifyContent: 'center',
      '.push': {
        maxWidth: '100%',
        flexBasis: '100%',
        marginBottom: '2rem',
        order: -1,
        '@media (min-width: 1024px)': {
          maxWidth: 'calc(1/3 * 100%)',
          flexBasis: 'calc(1/3 * 100%)',
          padding: '0 1rem',
          marginBottom: 0,
        },
        '&:first-child': {
          paddingLeft: 0,
          marginBottom: 0,
          order: 1,
          '@media (min-width: 1024px)': {
            paddingRight: '2rem',
            order: -1,
          }
        },
        '&:last-child': {
          paddingRight: 0,
          marginBottom: 0,
          '@media (min-width: 1024px)': {
            // paddingRight: '2rem',
            marginBottom: 0,
          }
        }
      }
    },
  },
  '.push-content': {
    maxWidth: 'none',
    padding: '0px 2rem',
    '@media (min-width: 1024px)': {
      padding: 0,
    },
    'h3': {
      color: 'black',
      // transform: 'translateX(-1.5rem)',
      '@media (min-width: 1024px)': {
        // transform: 'translateX(-3rem)',
        // minHeight: 96,
        marginBottom: '1rem',
        marginTop: '1rem',
      }
    },
    'a': {
      borderColor: 'black',
      color: 'black',
      '&:hover': {
        color: 'white',
        background: 'black',
      },
    },
    '&--picture': {
      maxWidth: 'none',
      margin: 0,
    }
  },
  '.challenge-panel-ranking': {
    maxWidth: '100%',
    flexBasis: '100%',
    marginBottom: '4rem',
    '@media (min-width: 1024px)': {
      maxWidth: 'calc(1/3 * 100%)',
      flexBasis: 'calc(1/3 * 100%)',
    }
  },
  '.ranking-push': {
    maxWidth: 'calc(1/2 * 100%)',
    flexBasis: 'calc(1/2 * 100%)',
    padding: '0 2rem',

    '@media (min-width: 1024px)': {
      maxWidth: 'calc(1/2 * 100%)',
      flexBasis: 'calc(1/2 * 100%)',
    }
  }
})


// WEBPACK FOOTER //
// ./src/styles/partials/panel.js